module.exports = __webpack_public_path__ + "img/intro-video-streamers-poster.c5d7a215.png";